import styled, { css } from 'styled-components';

type WrapperProps = {
  $highlight?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  padding: 13px 16px;
  position: relative;
  background-color: #f4f7f9;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-shadow: ${props =>
    props.$highlight
      ? '0 0 0 calc(1000vh + 100vw) rgba(0, 0, 0, 0.5)'
      : 'none'};
  ${props =>
    props.$highlight &&
    css`
      z-index: 99999;
    `};
`;
